import { IUserDenormalized } from '@dadohr/shared/domainTypes/user';
import { useEffect, useRef } from 'react';
import ENVS from '../env.json';
import { toFullName } from '../services/user';

interface Fullstory {
  identify(
    uid: string,
    data: { email: string; displayName: string; [key: string]: any }
  ): void;
  setUserVars: (userVars: { [key: string]: any }) => void;
  getCurrentSessionURL(): string;
  log(msg: string): void;
  log(level: string, msg: string): void;
  shutdown(): void;
  restart(): void;
  consent(consent: boolean): void;
  anonymize(): void;
}

export type FullstoryUserData = {
  user: Omit<IUserDenormalized, 'publicId'> & { id: string | null };
  org: { id: string; name: string };
};

export const useFullstoryIdentify = (
  app: string,
  currentUser: FullstoryUserData | null
) => {
  const currentUserId = useRef('');
  useEffect(() => {
    const FS: Fullstory = (window as any).FS;
    if (!FS) {
      console.log('Fullstory not found');
      return;
    }
    // in case of a logout
    if (!currentUser && currentUserId.current) {
      FS.anonymize();
      FS.setUserVars({ app });
    }

    if (currentUser && currentUser.user.id) {
      if (ENVS.fullstory.usersToIgnore.indexOf(currentUser.user.id) !== -1) {
        return;
      }
      const {
        user: { id, email },
        org: { name: orgName, id: orgId }
      } = currentUser;
      const displayName = toFullName(currentUser.user);
      if (currentUserId.current !== currentUser.user.id) {
        FS.identify(id, { email, displayName, orgName, orgId, app });
        currentUserId.current = id;
      } else {
        FS.setUserVars({ email, displayName, orgName, orgId, app });
      }
    } else {
      FS.setUserVars({ app });
    }
  }, [currentUser, app]);
};
